const selectTableSplit = {
  tables: {
    searchPlaceholder: 'Buscar',
  },
};

export default selectTableSplit;
